import React from 'react';

import '../styles/components/options/arrowButtons.scss';
import arrow from '../assets/arrow.png';

export default function ArrowButtons({ handleLeft, handleRight }) {
	return (
		<div className='button_wrapper'>
			<div className='left circle_button' onClick={handleLeft}>
				<img src={arrow} alt='' />
			</div>
			<div className='right circle_button' onClick={handleRight}>
				<img src={arrow} alt='' />
			</div>
		</div>
	);
}
